module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "start",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (_vm.$error('periodStart') || !_vm.startPeriodValid())
    }
  }, [_vm._v("\n                    Care period must start after the date of injury/accident (" + _vm._s(_vm.validationPeriodStart) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of care period must be before end of care period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "end",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  })], 1), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Period end must be before " + _vm._s(_vm.validationPeriodEnd) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Hours per Day"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('control', {
    attrs: {
      "before-after": "hours",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerDay),
      expression: "hoursPerDay"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "hours_per_day",
      "required": "",
      "min": "0",
      "max": "24",
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerDay)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerDay = $event.target.value
      }, _vm.calcRate]
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("at")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRate]
    }
  }, [_c('option', {
    attrs: {
      "value": "basic"
    }
  }, [_vm._v("Basic Rate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "aggregate"
    }
  }, [_vm._v("Aggregate")])])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gratuitous Care Discount"
    }
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gratuitousCare),
      expression: "gratuitousCare"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gratuitousCare) ? _vm._i(_vm.gratuitousCare, null) > -1 : (_vm.gratuitousCare)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gratuitousCare,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gratuitousCare = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gratuitousCare = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gratuitousCare = $$c
        }
      }, _vm.calcRate]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Applies the 'conventional 25% discount' to reflect the gratuitous nature of care.")])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "tip-icon": "formula",
      "before-after": "pound",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "sub_total",
      "modal-name": 'subTotal_' + _vm.uniqueId,
      "endpoint": "detailedCare",
      "payload": {
        period: _vm.getCarePeriod(this.index)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodTotal),
      expression: "periodTotal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'subTotal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d4c2334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/heads-of-loss/Period.vue
// module id = 1780
// module chunks = 0